export const META_DATA = {
  name: "White Bench",
  title: "White Bench Admin Dashboard  ",
  description:
    "White Bench is a modern, responsive admin dashboard available on ThemeForest. Ideal for building CRM, CMS, project management tools, and custom web applications with a clean UI, flexible layouts, and rich features.",
  author: "Freshbox Media Pvt Ltd",
  // username: "David Dev",
  keywords:
    "White Bench, admin dashboard, ThemeForest, Bootstrap 5 admin, responsive admin, CRM dashboard, CMS admin, web app UI, admin theme, premium admin template",
  version: "1.5.0",
};

export const currentYear = new Date().getFullYear();

export const formatDate = (date?: string | Date | null) => {
  if (!date) return "";

  return new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatTime = (time?: string | null) => {
  if (!time) return "";

  const [hours, minutes] = time.split(":");

  const date = new Date();
  date.setHours(Number(hours), Number(minutes), 0, 0);

  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
